import { useEffect, useState } from "react";
import { post } from "app/popleads/networking/RequestService";
import { EMPTY_SUGGESTIONS, readSuggestions } from "app/popleads/hooks/useEmailSuggestions";

/**
 * Suggested corporate emails for a LinkedIn profile that is not in the CRM yet (Pop-It mode), from the name and the
 * company LinkedIn shows (backend fn getLeadEmailSuggestions). Shown only, never verified here: no credit is spent
 * before the lead exists. Once Pop-It has saved the lead, the profile's own suggestions (useEmailSuggestions) are
 * verified in the background like any other profile's.
 *
 * @param {string} fullName
 * @param {string} company
 * @returns {{ suggestions: Array, emailPattern: ?Object, verifiable: boolean, loading: boolean }}
 */
const useLeadEmailSuggestions = (fullName, company) => {
    const [state, setState] = useState(EMPTY_SUGGESTIONS);
    const name = String(fullName || "").trim();
    const account = String(company || "").trim();

    useEffect(() => {
        if (!name || !account) {
            setState(EMPTY_SUGGESTIONS);
            return undefined;
        }
        let cancelled = false;
        setState({ ...EMPTY_SUGGESTIONS, loading: true });
        post({ fn: "getLeadEmailSuggestions", fullName: name, company: account })
            .then((res) => {
                if (!cancelled) setState({ ...readSuggestions(res), loading: false, verifying: false });
            })
            .catch(() => {
                if (!cancelled) setState(EMPTY_SUGGESTIONS);
            });
        return () => {
            cancelled = true;
        };
    }, [name, account]);

    return state;
};

export default useLeadEmailSuggestions;
